// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-2-main {
  height: 100vh;
  min-height: 100vh;
  /* background-color: var(--primary-bg-color); */
  /* display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden; */
  display: flex;
  align-items: center;
}
.login-2-main .inner-wrapper .login_text_div {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.login_text_div h1 {
  font-size: 3rem;
  margin-top: 8rem;
  color: white !important;
}
.login_text_div p {
  /* font-size: 1rem; */
  color: white !important;
}
.login-2-main .inner-wrapper {
  width: 95%;
}
.login-2-main .inner-wrapper .left {
  display: flex;
  /* flex-direction: column; */
  justify-content: center;
  align-items: center;
  text-align: center;
}
.login-2-main .inner-wrapper .left > :not(:last-child) {
  margin-bottom: 2rem;
}
.login-2-main .inner-wrapper .left img {
  max-width: 20rem;
}
.login-2-main .inner-wrapper .right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.login-2-main .inner-wrapper .right .ant-form-item input {
  background-color: transparent;
  color: var(--white);
}
.login-2-main .inner-wrapper .right .ant-form-item .ant-input-affix-wrapper {
  background-color: transparent;
}
.login-2-main .inner-wrapper .right .ant-form-item .ant-input-affix-wrapper ant-input-suffix {
  color: var(--white);
}
`, "",{"version":3,"sources":["webpack://./src/styles/pages/login2.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,+CAA+C;EAC/C;;;qBAGmB;EACnB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,4BAA4B;EAC5B,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mBAAmB;AACrB","sourcesContent":[".login-2-main {\r\n  height: 100vh;\r\n  min-height: 100vh;\r\n  /* background-color: var(--primary-bg-color); */\r\n  /* display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  overflow: hidden; */\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n.login-2-main .inner-wrapper .login_text_div {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex-direction: column;\r\n}\r\n.login_text_div h1 {\r\n  font-size: 3rem;\r\n  margin-top: 8rem;\r\n  color: white !important;\r\n}\r\n.login_text_div p {\r\n  /* font-size: 1rem; */\r\n  color: white !important;\r\n}\r\n.login-2-main .inner-wrapper {\r\n  width: 95%;\r\n}\r\n.login-2-main .inner-wrapper .left {\r\n  display: flex;\r\n  /* flex-direction: column; */\r\n  justify-content: center;\r\n  align-items: center;\r\n  text-align: center;\r\n}\r\n.login-2-main .inner-wrapper .left > :not(:last-child) {\r\n  margin-bottom: 2rem;\r\n}\r\n.login-2-main .inner-wrapper .left img {\r\n  max-width: 20rem;\r\n}\r\n.login-2-main .inner-wrapper .right {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  align-items: center;\r\n}\r\n.login-2-main .inner-wrapper .right .ant-form-item input {\r\n  background-color: transparent;\r\n  color: var(--white);\r\n}\r\n.login-2-main .inner-wrapper .right .ant-form-item .ant-input-affix-wrapper {\r\n  background-color: transparent;\r\n}\r\n.login-2-main .inner-wrapper .right .ant-form-item .ant-input-affix-wrapper ant-input-suffix {\r\n  color: var(--white);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
